import React, { createContext, useContext, ReactNode } from "react";
import { SanityTranslatedDocument } from "../model/common";

export interface SanityTranslationString {
  name: string;
  value: string;
}

export interface SanityTranslationStrings extends SanityTranslatedDocument {
  strings: SanityTranslationString[];
}

export interface TranslationStrings {
  [key: string]: string;
}

const TranslationStringsContext = createContext<TranslationStrings>({});

interface TranslationStringsProviderProps {
  strings: TranslationStrings;
  children: ReactNode;
}

export const TranslationStringsProvider = ({
  strings,
  children
}: TranslationStringsProviderProps) => (
  <TranslationStringsContext.Provider value={strings}>
    {children}
  </TranslationStringsContext.Provider>
);

export const useTranslationStrings = () =>
  useContext(TranslationStringsContext);
